export default class Analytics_Distributor
{
    constructor (name)
    {
        this.Name = name;
        // Contains object with Date, Orders, Sales and Profit
        this.Info = [];
    }

    GetSales(year, month)
    {
        for (let i = 0; i < this.Info.length; i++)
        {
            if (this.Info[i].Year === year &&
                this.Info[i].Month === month)
            {
                return this.Info[i];
            }
        }

        let newMonth = { Date: new Date(`${year}-${month}-1`), Year: year, Month: month, Orders: 0, Sales: 0, Profit: 0};
        this.Info.push(newMonth);

        return newMonth;
    }
}